var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-3"},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"animate-pulse w-full h-6 bg-grayPensive rounded mb-3"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }